import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Snackbar } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { SINGLE_JOB_MODE_BLOCK_KEY } from './canStartJob'

// Single Job Mode: what the operator sees after pressing a Start/Join that the mode withholds (another
// job is active on the machine). The button keeps its label and looks disabled; this explains why.
// Self-contained on purpose (no `AlertUI`): that one needs a router, and the Planned Jobs widget and
// its "Show all" modal are mounted without one in their tests.
const SingleJobModeBlockedSnackbar = ({ open = false, onClose = () => {} }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <Alert severity='warning' variant='filled' onClose={onClose} data-testid='single-job-mode-blocked-alert'>
        {t_(SINGLE_JOB_MODE_BLOCK_KEY)}
      </Alert>
    </Snackbar>
  )
}

SingleJobModeBlockedSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
}

export default SingleJobModeBlockedSnackbar
